(function (angular) {
  "use strict";

  angular.module("app").controller("likesController", likesController);

  likesController.$inject = ["$uibModalInstance", "$scope", "likes"];

  function likesController($uibModalInstance, $scope, likes) {
    var vm = this;

    vm.likes = likes.data;

    // methods
    vm.close = close;

    function close() {
      $uibModalInstance.close(false);
    }
  }
})(angular);
